(function () {
  'use strict';

  angular.module('app').component('processBooking', processBooking());

  function processBooking() {
    return {
      bindings: {
        booking: '=',
        onBookingProcessed: '&',
      },
      controller: ProcessBookingComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/bookings/components/process-booking/process-booking.component.html',
    };
  }

  ProcessBookingComponent.$inject = ['UtilService', 'BookingService'];

  function ProcessBookingComponent(UtilService, BookingService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    // Methods
    vm.saveProcessBooking = saveProcessBooking;

    function saveProcessBooking(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.formErrors = true;
        return;
      }

      // console.log(vm.booking);
      // return;

      vm.sendingForm = true;
      BookingService.updateBookingStatus(vm.booking, 'processing', vm.processingReason).then(
        function (data) {
          if (!data.errors) {
            vm.onBookingProcessed({ bookingObj: data });
          }

          vm.sendingForm = false;
        }
      );
    }
  }
})();
